import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { deleteMap } from '../services/mapServices'

export function useMapDelete() {
  const queryClient = useQueryClient()

  const {
    mutate: mapDelete,
    isLoading: isLoadingMapDelete,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: deleteMap,
  })

  useEffect(() => {
    if (isSuccess) {
      queryClient.removeQueries({ queryKey: ['maps'] })
    }
  }, [isSuccess, queryClient])

  return {
    mapDelete,
    isLoadingMapDelete,
    error,
    isSuccessMapDelete: isSuccess,
  }
}